import React, { useContext, useEffect, useState } from "react";
import {
  adminSsoAuth,
  validateAuthToken,
  getTimeZoneApi,
  getLicenseVersionApi,
  signUp,
} from "../../services/authService";
import { Base64 } from "../../util/encoder";
import Messages from "./Messages";
import BanScripts from "./BanScripts";
import Ledger from "./Ledger";
import Invoice from "./Invoice";
import ChangePassword from "./ChangePassword";
import { DisclaimerModalContext, ServerListContext, SettingViewContext, SocketContext, SwalContext, ThemeContext } from "../../layout/BaseLayout";
import Feedback from "./Feedback";
import DisclaimerModal from "./DisclaimerModal";
import Draggable from "react-draggable";
import Modal from "react-bootstrap/Modal";
import { ModalDialog } from "react-bootstrap";
import { useSwipeable } from "react-swipeable";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { logout } from "../../util/auth";
import withReactContent from "sweetalert2-react-content";
import { useNavigate, useParams } from "react-router-dom";

const eodModal = (props) => {
  return (
    <Draggable handle=".modal-header">
      <ModalDialog {...props} />
    </Draggable>
  );
};

const Setting = () => {
  let toast = useContext(ThemeContext);
  let [settingView, setSettingView] = useContext(SettingViewContext)
  let token = sessionStorage.getItem("token");
  let socket = useContext(SocketContext);
  let savedData = localStorage.getItem("savedAccounts");
  savedData = JSON.parse(savedData);
  let curLogin = localStorage.getItem("curLogin");
  curLogin = JSON.parse(curLogin);
  let Swal = useContext(SwalContext);
  Swal = withReactContent(Swal);
  // let params = useParams();
  let disclaimerModal = useContext(DisclaimerModalContext);
  let [serverList, setServerList] = useContext(ServerListContext);
  const [isSoundEnable, setIsSoundEnable] = useState(() => {
    const saved = localStorage.getItem("isSoundEnable");
    return saved === "true";
  });
  let navigate = useNavigate();

  const [view, setView] = useState("main");
  const [svrList, setSvrList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [versionDetail, setVersionDetail] = useState({});
  const [svrSearchList, setSvrSearchList] = useState([]);
  const [selectedServer, setSelectedServer] = useState({});
  const [optionOpen, setOptionOpen] = useState(false);

  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const [isRemember, setIsRemember] = useState(true);
  const [savedAccounts, setSavedAccounts] = useState({});
  const [deletedLoginId, setDeletedLoginId] = useState(null);
  const [showDisclaimerModal, setShowDisclaimerModal] = useState(false);
  const [swipedRow, setSwipedRow] = useState(null);
  const [leverageSelection, setLeverageSelection] = useState("1:100");
  const [depositSelection, setDepositSelection] = useState("10000");
  const [registerDisabled, setRegisterDisabled] = useState(false);
  const [isOpenDemo, setIsOpenDemo] = useState(false);
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const urlParams = new URLSearchParams(window.location.search);
  const authkey = urlParams.get('oid');
  const paramId = authkey;

  const defaultObj = {
    "firstName": "",
    "lastName": "",
    "mobile": "",
    "email": "",
    "investorPass": "",
    "userPass": ""
  }

  const [registerList, setRegisterList] = useState({ ...defaultObj });

  const openSettingMenu = (type, val) => {
    if (!!token && !!curLogin) {
      setView(type);
      if (type === "changepass") {
        setOptionOpen(val)
      }
    } else {
      Swal.fire({
        showConfirmButton: true,
        text: "Please login",
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok'
      })
    }
  }

  const registerOnChange = (fld, val) => {
    let dta = { ...registerList };
    dta[fld] = val;
    setRegisterList({ ...dta });
  }

  useEffect(() => {
    if (!!view) {
      setSettingView(view);
    }
  }, [view])

  useEffect(() => {
    // if (!!token) {
    // getServers(paramId).then((res) => {
    //   if (res.isSuccess) {
    //     setSvrList([...res.data]);
    //   }
    // });
    if (!!savedData && savedData !== "") {
      // setSavedAccounts({ ...JSON.parse(savedData) });
      setSavedAccounts({ ...savedData });
    }
    if (!!curLogin && curLogin !== "") {
      // setSelectedServer({ ...JSON.parse(curLogin) });
      setSelectedServer({ ...curLogin });
    } else if (!!savedData && savedData !== "") {
      setView("accounts");
    }
    getVersionDetail();
    // }
    // if (!!!token) {
    //   toast.info("You must be logged in to use the product");
    // }
  }, []);

  const getVersionDetail = () => {
    let data = {
      operatorId: curLogin?.operatorId,
      versionDeviceType: "CLIENTWEB",
    };
    getLicenseVersionApi(data)
      .then((res) => {
        if (!!res) {
          if (res?.isSuccess) {
            setVersionDetail({ ...res?.data });
          }
        }
      })
      .catch((err) => {
        toast.error(`${err}`);
      });
  };

  useEffect(() => {
    let lst = serverList;
    if (isOpenDemo) {
      if (searchText === "") {
        lst = lst.filter((elem) => elem.operatorId === "MOD")
      } else {
        lst = lst.filter((elm) => {
          return (
            elm.serverDisplayName
              .toLowerCase()
              .includes(searchText.toLowerCase()) ||
            elm.companyName.toLowerCase().includes(searchText.toLowerCase())
          );
        });
      }
      setSvrSearchList([...lst]);
    } else {
      if (searchText === "") {
        setSvrSearchList([]);
      } else {
        lst = lst.filter((elm) => {
          return (
            elm.serverDisplayName
              .toLowerCase()
              .includes(searchText.toLowerCase()) ||
            elm.companyName.toLowerCase().includes(searchText.toLowerCase())
          );
        });
        setSvrSearchList([...lst]);
      }
    }
  }, [searchText, serverList, isOpenDemo]);

  const apendUrl = (parentsDomain) => {
    let urlServer = "https://api";
    // if (parentsDomain == "tradeprint.in") {
    //     urlServer = `${urlServer}-dev.${parentsDomain}`
    // } else {
    urlServer = `${urlServer}.${parentsDomain}`;
    // }
    return urlServer;
  };

  const adminLoginApi = () => {
    if (loginId.length == 0 && password.length == 0) {
      Swal.fire({
        showConfirmButton: true,
        text: "Please enter your information.",
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok'
      })
    } else if (loginId.length == 0) {
      Swal.fire({
        showConfirmButton: true,
        text: "Please enter your UserId.",
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok'
      })
    } else if (password.length == 0) {
      Swal.fire({
        showConfirmButton: true,
        text: "Please enter your Password.",
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok'
      })
    } else {
      let serverParams = new Object();
      serverParams["localid"] = "1";
      serverParams["operatorId"] = selectedServer.operatorId;
      serverParams["companyName"] = selectedServer.companyName;
      serverParams["licenseId"] = selectedServer.licenseId;
      serverParams["primaryDomain"] = selectedServer.primaryDomain;
      serverParams["parentsDomain"] = selectedServer.parentsDomain;
      serverParams["serverDisplayName"] = selectedServer.serverDisplayName;
      serverParams["licenseLogo"] = selectedServer.licenseLogo;
      serverParams["loginid"] = loginId;
      serverParams["password"] = Base64.encode(password);
      serverParams["islogin"] = true;
      serverParams["date"] = new Date().toLocaleString();
      let urlServer = apendUrl(selectedServer.parentsDomain);

      let reqParams = new Object();
      reqParams["username"] = loginId;
      reqParams["password"] = password;
      reqParams["licenseId"] = selectedServer.licenseId;
      adminSsoAuth(reqParams, urlServer).then((res) => {
        if (!!res && !!res?.isSuccess) {
          setPreferenceToken(res?.data?.token);
          serverParams["loginName"] = res?.data?.name;
          validateToken(serverParams, loginId, urlServer);
        } else {
          Swal.fire({
            showConfirmButton: true,
            text: res?.exception?.message,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Ok'
          })
        }
      });
    }
  };

  const loginWithSaved = (acc) => {
    let urlServer = apendUrl(acc.parentsDomain);
    let reqParams = new Object();
    reqParams["username"] = acc.loginid;
    reqParams["password"] = Base64.decode(acc.password);
    reqParams["licenseId"] = acc.licenseId;
    adminSsoAuth(reqParams, urlServer).then((res) => {
      if (!!res && !!res?.isSuccess) {
        setPreferenceToken(res?.data?.token);
        validateToken(acc, loginId, urlServer);
      } else {
        toast.error(`${res?.exception?.message}`);
      }
    });
  };

  const saveServerClientList = async (serverParams) => {
    let savedData = localStorage.getItem("savedAccounts");
    let dt = {};
    if (!savedData || savedData === "") {
      dt[serverParams.licenseId + "-" + serverParams.loginid] = serverParams;
    } else {
      dt = JSON.parse(savedData);
      dt[serverParams.licenseId + "-" + serverParams.loginid] = serverParams;
    }
    setSavedAccounts({ ...dt });
    localStorage.setItem("savedAccounts", JSON.stringify(dt));
  };

  const validateToken = async (serverParams, loginID, urlServer) => {
    validateAuthToken(urlServer).then((res) => {
      if (res.isSuccess) {
        if (res.data.role === "Client") {
          if (isRemember) {
            saveServerClientList(serverParams);
          }
          setSelectedServer({ ...serverParams });
          let serverPrms = { ...serverParams };
          serverPrms["localIP"] = res.data.ip;
          serverPrms["intime"] = res.data.intime;
          serverPrms["isreadonlypassword"] = res.data.isreadonlypassword;
          localStorage.setItem("curLogin", JSON.stringify(serverPrms));
          localStorage.setItem("baseUrl", urlServer);
          localStorage.setItem(
            "sigRurl",
            `https://sglr.${serverPrms.primaryDomain
              ? serverPrms.primaryDomain
              : serverPrms.accessDomain
            }:6020/offers`
          );
          window.location.pathname = '/';
          localStorage.setItem("modalshow", 'true')
        }
      } else {
        alert(res.exception.message);
      }
    });
  };

  // useEffect(() => {
  //   if (isAccountChanged && !!token && !!curLogin) {
  //     disclaimerModal({ showDisModal: true });
  //   }
  // }, [isAccountChanged])

  // const getTimeZone = async () => {
  //   let getTimeZoneApiRes = await getTimeZoneApi();
  //   if (!!getTimeZoneApiRes) {
  //     if (getTimeZoneApiRes?.isSuccess) {
  //       localStorage.setItem('timezone', JSON.stringify(getTimeZoneApiRes?.data));
  //       window.location.href = '/';
  //     } else {
  //       toast.error(!!getTimeZoneApiRes?.exception && !!getTimeZoneApiRes?.exception?.message && getTimeZoneApiRes?.exception?.message);
  //     }
  //   } else {
  //     toast.error("Timezone error");
  //   }
  // }

  const setPreferenceToken = async (token) => {
    sessionStorage.setItem("token", token);
  };

  const [isAcceptChecked, setIsAcceptChecked] = useState(false);

  const handleAcceptCheckboxChange = () => {
    setIsAcceptChecked(!isAcceptChecked);
  }

  const handleCheckboxChange = (e) => {
    setIsSoundEnable(e.target.checked)
  };

  useEffect(() => {
    localStorage.setItem("isSoundEnable", isSoundEnable);
  }, [isSoundEnable]);

  const deleteAccount = (id) => {
    setSavedAccounts((prevAcc) => {
      const updatedAccounts = { ...prevAcc };
      const accountToDelete = updatedAccounts[id];
      if (!accountToDelete) return prevAcc;
      const isCurrentUser = !!curLogin && curLogin.loginid.toString() === accountToDelete.loginid;

      delete updatedAccounts[id];

      localStorage.setItem("savedAccounts", JSON.stringify(updatedAccounts));

      if (isCurrentUser) {
        localStorage.removeItem("curLogin");
        logout();
      }

      return updatedAccounts;
    });
  };

  const SwipeableRow = ({ id, data, swipedRow, setSwipedRow, loginWithSaved, deleteAccount }) => {
    const handlers = useSwipeable({
      onSwipedLeft: () => setSwipedRow(id),
      onSwipedRight: () => setSwipedRow(null),
      // preventScrollOnSwipe: true,
      trackMouse: true,
    });

    return (
      <div className="swipe-container" {...handlers}>
        <div className={`swipeable-row ${swipedRow === id ? "swiped" : ""}`}
          onClick={() => {
            if (swipedRow === id) {
              setSwipedRow(null);
            } else {
              loginWithSaved(data)
            }
          }
          }
        >
          <div className="row-content swapflax">
            <img src={data.licenseLogo} alt="" className="log-logo mr-2" />
            <div>
              <div className="font-14">{data.serverDisplayName}</div>
              <div className="font-12">{data.loginid}</div>
              <div className="font-12">{data.loginName}</div>
              <div className="font-12">{data.companyName}</div>
            </div>
          </div>
        </div>

        <button
          className={`delete-btn ${swipedRow === id ? "visible" : ""}`}
          onClick={(e) => {
            e.stopPropagation();
            deleteAccount(id);
          }}
        >
          <span className="trashicon">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5M8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5m3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0" />
            </svg>
          </span>
        </button>
      </div>
    );
  };

  const generatePassword = (length) => {
    const uppercaseChar = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const lowercaseChar = 'abcdefghijklmnopqrstuvwxyz';
    const digit = '0123456789';

    let password = '';
    for (let i = 0; i < length; i++) {
      const charset = i % 3 === 0 ? uppercaseChar : i % 3 === 1 ? lowercaseChar : digit;
      const ramdomChar = charset.charAt(Math.floor(Math.random() * charset?.length));
      password += ramdomChar
    }

    const hasupperCase = /[A-Z]/.test(password);
    const haslowerCase = /[a-z]/.test(password);
    const hasDigit = /[0-9]/.test(password);
    const isStrong = hasupperCase && haslowerCase && hasDigit

    if (isStrong) {
      return password;
    } else {
      password = "";
    }
  }

  useEffect(() => {
    const newRandomInvestorPass = generatePassword(6);
    const newRandomUserPass = generatePassword(6);
    setRegisterList({ ...registerList, investorPass: newRandomInvestorPass, userPass: newRandomUserPass });
  }, [view === "Register"])

  const registerApi = () => {
    let body = {
      "clientName": `${registerList.firstName}-${registerList.lastName}`,
      "leverage": leverageSelection,
      "mobileNumber": registerList.mobile,
      "email": registerList.email,
      "currency": "USD",
      "userPassword": registerList.userPass,
      "investorPassword": registerList.investorPass,
      "operatorId": selectedServer.operatorId,
      "creditAmount": depositSelection,
    }

    let isValid = true;
    if (!registerList.firstName) {
      isValid = false;
    }
    if (!registerList.lastName) {
      isValid = false;
    }
    if (!registerList.mobile || registerList.mobile?.length < 10) {
      isValid = false;
    }
    if (!registerList.email || !emailRegex.test(registerList.email)) {
      isValid = false;
    }

    if (isValid) {
      signUp(body).then((res) => {
        if (res.isSuccess) {
          setRegisterList({ ...defaultObj });
          setView("login")
          // toast.success(res?.successMessage);
        } else {
          // toast.error(res?.exception?.message)
        }
      }).catch(error => {
        console.log(error);
      })
    }

  }

  return (
    <>
      {/* LOGIN START */}
      {view === "main" && (
        <div className="bgmain h100">
          {/* HEADER START */}
          <div className="header">
            <div className="header-box">
              <div className="himg">&nbsp;</div>
              <div className="header-name">Settings</div>
              <div className="himg">&nbsp;</div>
            </div>
          </div>
          {/* HEADER END */}
          {/* MIDDLE START */}
          {/* LOGIN DATA START */}
          <div className="middle bgmain mt-3">
            <div className="settingbox ">
              {!!token && !!curLogin && (
                <div
                  onClick={() => {
                    setView("accounts");
                  }}
                >
                  <div className="settinglogo">
                    <img src={curLogin?.licenseLogo} alt="" />
                  </div>
                  <div className="text-center text-black font-16">
                    {curLogin?.companyName}
                  </div>
                  <div className="text-center text-grey font-12">
                    {curLogin?.serverDisplayName}{" "}
                    <img
                      src={"/images/right-arrow.svg"}
                      alt=""
                      className="rightarrow ml-2"
                    />
                  </div>
                  <div className="text-center text-grey font-12">
                    {curLogin?.loginid}
                  </div>
                  <div className="text-center text-grey font-12">
                    {curLogin?.loginName}
                  </div>
                </div>
              )}
              {/* <hr
                style={{ display: !!token && !!curLogin ? "none" : "block" }}
              ></hr> */}
              <div
                className="himg"
                onClick={() => {
                  setView("accounts");
                }}
                style={{ display: !!token && !!curLogin ? "none" : "flex", justifyContent: "center" }}
              >
                <span>
                  &nbsp;
                </span>
                <span className="font-14 v-middle f-arial text-blue">
                  Choose Server
                </span>
                <span className="float-right right-arrow">
                  <img
                    src={"/images/right-arrow.svg"}
                    alt=""
                    className="mr-2 settingheight"
                  />
                </span>
              </div>
              <hr></hr>
              <div
                className="himg"
                onClick={() => {
                  setView("broker");
                  setIsOpenDemo(false);
                }}
              >
                <span>
                  <img src={"/images/Newaccount.svg"} alt="" className="mr-2" />
                </span>
                <span className="font-14 text-black v-middle f-arial">
                  New Account
                </span>
                <span className="float-right">
                  <img
                    src={"/images/right-arrow.svg"}
                    alt=""
                    className="mr-2 settingheight"
                  />
                </span>
              </div>
              <hr></hr>
              <div
                className="himg"
                onClick={() => {
                  setView("broker");
                  setIsOpenDemo(true);
                }}
              >
                <span>
                  <img src={"/images/Newaccount.svg"} alt="" className="mr-2" />
                </span>
                <span className="font-14 text-black v-middle f-arial">
                  Open Demo Account
                </span>
                <span className="float-right">
                  <img
                    src={"/images/right-arrow.svg"}
                    alt=""
                    className="mr-2 settingheight"
                  />
                </span>
              </div>
              <hr></hr>
              <div
                className="himg"
                onClick={() => {
                  openSettingMenu("messages")
                }}
              >
                <span>
                  <img src={"/images/News.svg"} alt="" className="mr-2" />
                </span>
                <span className="font-14 text-black v-middle f-arial">
                  Message
                </span>
                <span className="float-right">
                  <img
                    src={"/images/right-arrow.svg"}
                    alt=""
                    className="mr-2 settingheight"
                  />
                </span>
              </div>
              <hr></hr>
              <div
                className="himg"
                onClick={() => {
                  openSettingMenu("ban");
                }}
              >
                <span>
                  <img src={"/images/ben1.svg"} alt="" className="mr-2" />
                </span>
                <span className="font-14 text-black v-middle f-arial">
                  Ban Scripts
                </span>
                <span className="float-right">
                  <img
                    src={"/images/right-arrow.svg"}
                    alt=""
                    className="mr-2 settingheight"
                  />
                </span>
              </div>
              <hr></hr>
              <div
                className="himg"
                onClick={() => {
                  openSettingMenu("invoice");
                }}
              >
                <span>
                  <img src={"/images/invoice.svg"} alt="" className="mr-2" />
                </span>
                <span className="font-14 text-black v-middle f-arial">
                  Invoice
                </span>
                <span className="float-right">
                  <img
                    src={"/images/right-arrow.svg"}
                    alt=""
                    className="mr-2 settingheight"
                  />
                </span>
              </div>
              <hr></hr>
              <div
                className="himg"
                onClick={() => {
                  openSettingMenu("ledger");
                }}>
                <span>
                  <img src={"/images/ledger.svg"} alt="" className="mr-2" />
                </span>
                <span className="font-14 text-black v-middle f-arial">
                  Ledger
                </span>
                <span className="float-right">
                  <img
                    src={"/images/right-arrow.svg"}
                    alt=""
                    className="mr-2 settingheight"
                  />
                </span>
              </div>
              <hr></hr>
              <div
                className="himg"
                onClick={() => {
                  openSettingMenu("changepass", true);
                }}
              >
                <span>
                  <img
                    src={"/images/changepassword1.svg"}
                    alt=""
                    className="mr-2"
                  />
                </span>
                <span className="font-14 text-black v-middle f-arial">
                  Change Password
                </span>
                <span className="float-right">
                  <img
                    src={"/images/right-arrow.svg"}
                    alt=""
                    className="mr-2 settingheight"
                  />
                </span>
              </div>
              <hr></hr>
              <div
                className="himg"
                onClick={() => {
                  openSettingMenu("feedback")
                }}
              >
                <span>
                  <img src={"/images/feedback.svg"} alt="" className="mr-2" />
                </span>
                <span className="font-14 text-black v-middle f-arial">
                  Feedback
                </span>
                <span className="float-right">
                  <img
                    src={"/images/right-arrow.svg"}
                    alt=""
                    className="mr-2 settingheight"
                  />
                </span>
              </div>
              <hr></hr>
              <div
                className="himg"
                onClick={() => {
                  disclaimerModal({ showDisModal: true });
                }}>
                <span>
                  <img src={"/images/disclaimer.svg"} alt="" className="mr-2" />
                </span>
                <span className="font-14 text-black v-middle f-arial">
                  Disclaimer
                </span>
                <span className="float-right">
                  <img
                    src={"/images/right-arrow.svg"}
                    alt=""
                    className="mr-2 settingheight"
                  />
                </span>
              </div>
              <hr></hr>
              <div
                className="himg">
                <span>
                  <img src={"/images/sound.svg"} alt="" className="mr-2" />
                </span>
                <span className="font-14 text-black v-middle f-arial">
                  Sound On/Off
                </span>
                <span className="float-right">
                  <div className="custom-control custom-switch">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      id="customSwitch1"
                      checked={isSoundEnable}
                      onChange={handleCheckboxChange}
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="customSwitch1"
                    >
                    </label>
                  </div>
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {view === "main" &&
        <div>
          <span className="font-14 text-black v-middle version-fixed">
            Version {versionDetail?.versionNumber}
          </span>
        </div>
      }

      {/* MULTI LOGIN START */}
      {view === "accounts" && (
        <div className="bgmain h100 ">
          {/* HEADER START */}
          <div className="header">
            <div className="header-box">
              <div
                className="himg"
                onClick={() => {
                  setView("main");
                }}
              >
                <img src={"/images/back-arrow-blue.svg"} alt="" />
              </div>
              <div className="header-name ">Accounts</div>
              <div
                className="himg"
                onClick={() => {
                  setView("broker");
                }}
              >
                <img src={"/images/plus.svg"} alt="" />
              </div>
            </div>
          </div>
          {/* HEADER END */}
          {/* MIDDLE START */}
          {/* LOGIN DATA START */}
          <div className="middle bgmain mt-3">
            <div className="">
              <div>
                <table className="table w-100  whitespace mb-0">
                  <tbody>
                    {!!Object.keys(savedAccounts) && Object.keys(savedAccounts)?.length > 0 ? Object.keys(savedAccounts).map((id) => {
                      let data = savedAccounts[id];
                      return (
                        <SwipeableRow
                          key={data?.loginid}
                          id={id}
                          data={data}
                          swipedRow={swipedRow}
                          setSwipedRow={setSwipedRow}
                          loginWithSaved={loginWithSaved}
                          deleteAccount={deleteAccount}
                        />
                      );
                    }) : <div className="nodatafound">No Data Found</div>}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {/* LOGIN DATA END */}

          {/* MIDDLE END */}
        </div>
      )}
      {/* MULTI LOGIN END */}

      {/* BROKERS LOGIN START */}
      {view === "broker" && (
        <div className="">
          {/* HEADER START */}
          <div className="header">
            <div className="header-box">
              <div
                className="font-14 himg text-blue w-25"
                onClick={() => {
                  setSearchText("");
                  // if (!!savedData) {
                  //   setView("accounts");
                  // } else {
                  //   setView("main");
                  // }
                  setView("main");
                  setIsOpenDemo(false);
                }}
              >
                <img
                  src={"/images/back-arrow-blue.svg"}
                  className="mr-1"
                  alt=""
                />
                Accounts
              </div>
              <div className="header-name w-50 text-center">Brokers</div>
              <div className="himg w-25">&nbsp;</div>
            </div>
            <div className="search">
              <div className="form-group has-search">
                <span className="fa fa-search form-control-feedback"></span>
                <input
                  type="text"
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                  }}
                  className="form-control"
                  placeholder="enter company or server name"
                />
              </div>
            </div>
          </div>
          {/* HEADER END */}
          {/* MIDDLE START */}
          {/* LOGIN DATA START */}
          <div className="middle bgmain mt-3">
            {svrSearchList.map((srv) => {
              return (
                <div
                  key={srv?.licenseId}
                  className="settingbox"
                  onClick={() => {
                    setSelectedServer({ ...srv });
                    setView("login");
                  }}
                >
                  <div>
                    <table className="table w-100  whitespace mb-0">
                      <tbody>
                        <tr className="">
                          <td className="w-40 v-middle">
                            <img
                              src={srv.licenseLogo}
                              alt=""
                              className=" log-logo mr-2"
                            />
                          </td>
                          <td>
                            <div className="font-14">
                              {srv.companyName}
                            </div>
                            <div className="font-12">{srv.serverDisplayName}</div>
                          </td>
                          <td className="width-info v-middle">
                            <img
                              src={"/images/info.svg"}
                              alt=""
                              className=" log-logo mr-2"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              );
            })}
          </div>
          {/* LOGIN DATA END */}

          {/* MIDDLE END */}
        </div>
      )}
      {/* BROKERS LOGIN END */}

      {/* LOGIN  START */}
      {view === "login" && (
        <div className="">
          {/* HEADER START */}
          <div className="header">
            <div className="header-box">
              <div
                className="font-14 himg text-blue w-25"
                onClick={() => {
                  setView("broker");
                }}
              >
                <img src={"/images/back-arrow-blue.svg"} className="" alt="" />
              </div>
              <div className="header-name w-50 text-center">Login</div>
              <div className="himg w-25">&nbsp;</div>
            </div>
          </div>
          {/* HEADER END */}
          {/* MIDDLE START */}
          {/* LOGIN DATA START */}
          <div className="middle bgmain mt-1">
            <div className="settingbox">
              {selectedServer.operatorId === "MOD" &&
                <>
                  <div className="w-100 bggreycolor demomainpadding">Register New Account</div>
                  <div className="demomainpadding" onClick={() => { setView("Register"); setRegisterList({ ...defaultObj }); setIsAcceptChecked(false) }}>
                    <div>
                      <div className="text-black font-16">Demo Account</div>
                      <div className=" text-black font-12">Register an account to learn trading and test your strategies </div>
                    </div>
                    <div><span class="float-right"><img src="/images/right-arrow.svg" alt="" class="mr-2 demoaarow" /></span></div>
                  </div>
                </>
              }
              <div>
                <table className="table w-100  whitespace mb-0 loginscreen">
                  <tbody>
                    <tr className="w-100 bggreycolor">
                      <td colSpan={2}>Use Existing Account</td>
                    </tr>
                    <tr>
                      <td className="w-25 font-12">Server</td>
                      <td className="w-75 font-12 text-right">
                        {selectedServer.serverDisplayName}
                      </td>
                    </tr>
                    <tr>
                      <td className="w-25 font-12">Login</td>
                      <td className="w-75 font-12 text-right">
                        <input
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          onChange={(e) => {
                            setLoginId(e.target.value);
                          }}
                          value={loginId}
                          className="inputborder font11 w-100  ml-2 h20 "
                          // maxLength="50"
                          // autoComplete="off"
                          placeholder="Please enter login id"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td className="w-25 font-12">Password</td>
                      <td className="w-75 font-12 text-right">
                        <input
                          type="password"
                          onChange={(e) => {
                            setPassword(e.target.value);
                          }}
                          value={password}
                          className="inputborder font11 w-100  ml-2 h20 "
                          maxLength="50"
                          autoComplete="off"
                          placeholder="Please enter password"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td className="w-25 font-12">Save Password</td>
                      <td className="w-75 font-12 font-bold text-right">
                        {/* <div className="form-group form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={isRemember}
                            onChange={() => {
                              setIsRemember(!isRemember);
                            }}
                          />
                        </div> */}
                        <div className="custom-control custom-switch">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="customSwitch1"
                            checked={isRemember}
                            onChange={() => {
                              setIsRemember(!isRemember);
                            }}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="customSwitch1"
                          >
                          </label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={2} className="w-25 font-12">
                        <button
                          onClick={() => {
                            adminLoginApi();
                          }}
                          className="btnmain"
                        >
                          Login
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {/* LOGIN DATA END */}

          {/* MIDDLE END */}
        </div>
      )}
      {/* LOGIN END */}
      {optionOpen && (
        <div className="tradepopupbox">
          <div className="tradebox" onClick={() => setOptionOpen(false)}>
            <div
              className="tradebox-inner"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
              }}
            >
              <div className="trade-main-name bg-tr mb-2">
                <ul className="trade-name-all ">
                  <li
                    onClick={() => {
                      setView("changePassword");
                      setOptionOpen(false);
                    }}
                  >
                    Master Password
                  </li>
                  <li
                    onClick={() => {
                      setView("changeApiPassword");
                      setOptionOpen(false);
                    }}
                  >
                    API Password
                  </li>
                </ul>
              </div>
              <div
                className="trade-cancel"
                onClick={() => setOptionOpen(false)}
              >
                Cancel
              </div>
            </div>
          </div>
        </div>
      )}
      {/* MESSAGE ALL SCREEN START */}
      {/* MESSAGE START */}

      {view === "Register" &&
        <div className="">
          <div className="header">
            <div className="header-box">
              <div
                className="font-14 himg text-blue w-25"
                onClick={() => {
                  setView("broker");
                }}
              >
                <img src={"/images/back-arrow-blue.svg"} className="" alt="" />
              </div>
              <div className="header-name w-50 text-center">Register</div>
              <div className="himg w-25">&nbsp;</div>
            </div>
            <div className="middle bgmain mt-1">
              <div className="settingbox">
                <div>
                  <table className="table w-100  whitespace mb-0 loginscreen">
                    <tbody>
                      <tr className="w-100 bggreycolor">
                        <td colSpan={2}>Personal Information</td>
                      </tr>
                      <tr>
                        <td className="w-25 font-12">First Name</td>
                        <td className="w-75 font-12 text-right">
                          <input
                            type="text"
                            onChange={(e) => {
                              registerOnChange("firstName", e.target.value);
                            }}
                            value={registerList.firstName}
                            className="inputborder font11 w-100  ml-2 h20 "
                            maxLength="50"
                            autoComplete="off"
                            placeholder="min 2 chars"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="w-25 font-12">Last Name</td>
                        <td className="w-75 font-12 text-right">
                          <input
                            type="text"
                            onChange={(e) => {
                              registerOnChange("lastName", e.target.value);
                            }}
                            value={registerList.lastName}
                            className="inputborder font11 w-100  ml-2 h20 "
                            maxLength="50"
                            autoComplete="off"
                            placeholder="min 2 chars"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="w-25 font-12">Mobile</td>
                        <td className="w-75 font-12 text-right">
                          <PhoneInput
                            country={"in"}
                            value={registerList.mobile}
                            onChange={(value, country) => {
                              if (!value.startsWith("+")) {
                                value = "+" + value;
                              }
                              registerOnChange("mobile", value);
                            }}
                            inputClass="inputborder font11 w-100 ml-2 h20"
                            containerClass="phone-container"
                            buttonClass="flag-dropdown"
                            inputProps={{
                              required: true,
                              autoComplete: "off",
                            }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="w-25 font-12">Email</td>
                        <td className="w-75 font-12 text-right">
                          <input
                            type="email"
                            onChange={(e) => {
                              registerOnChange("email", e.target.value);
                            }}
                            onBlur={() => {
                              if (!emailRegex.test(registerList.email) && registerList.email !== "") {
                                toast.warn("Invalid email format");
                              }
                            }}
                            value={registerList.email}
                            className="inputborder font11 w-100  ml-2 h20 "
                            maxLength="50"
                            autoComplete="off"
                            placeholder="name@company.com"
                          />
                        </td>
                      </tr>
                      <tr className="w-100 bggreycolor">
                        <td colSpan={2}>Account Information</td>
                      </tr>
                      <tr>
                        <td className="w-25 font-12">Server</td>
                        <td className="w-75 font-12 text-grey text-right">
                          {selectedServer.serverDisplayName}
                        </td>
                      </tr>
                      <tr onClick={() => setView("leverage")}>
                        <td className="w-25 font-12">Leverage</td>
                        <td className="w-75 font-12 text-grey text-right">
                          {leverageSelection}
                          <span class="float-right"><img src="/images/right-arrow.svg" alt="" class="ml-2 demoaarow15" /></span>
                        </td>
                      </tr>
                      <tr onClick={() => setView("deposit")}>
                        <td className="w-25 font-12">Deposit</td>
                        <td className="w-75 font-12 text-grey text-right">
                          {depositSelection + " USD"}
                          <span class="float-right"><img src="/images/right-arrow.svg" alt="" class="ml-2 demoaarow15" /></span>
                        </td>
                      </tr>
                      <tr className="w-100 bggreycolor">
                        <td colSpan={2} className="">&nbsp;</td>
                      </tr>
                      <tr className="">
                        <td className="w-25 font-12">Accept</td>
                        <td className="w-75 font-12 font-bold text-right">
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="customSwitch1"
                              checked={isAcceptChecked}
                              onChange={handleAcceptCheckboxChange}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="customSwitch1"
                            >
                            </label>
                          </div>
                        </td>
                      </tr>
                      <tr className="w-100 bggreycolor">
                        <td colSpan={2} className="">By enabling "Accept" you agree with the terms and conditions for opening an account and the data protection policy</td>
                      </tr>
                      <tr className="w-100 bggreycolor">
                        <td colSpan={2} className="h60">&nbsp;</td>
                      </tr>
                      <tr className="w-100 bggreycolor">
                        <td colSpan={2} className="text-center">This is demo account valid up to 7 days</td>
                      </tr>
                      <tr>
                        <td colSpan={2} className="w-25 font-12">
                          <button
                            onClick={() => {
                              registerApi();
                            }}
                            className="btnmain btn-primary w-100"
                            disabled={!isAcceptChecked}
                          >
                            Register
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      {view === "leverage" &&
        <div className="">
          <div className="header">
            <div className="header-box">
              <div
                className="font-14 himg text-blue w-25"
                onClick={() => {
                  setView("Register");
                }}
              >
                <img src={"/images/back-arrow-blue.svg"} className="" alt="" />
              </div>
              <div className="header-name w-50 text-center">Leverage</div>
              <div className="himg w-25">&nbsp;</div>
            </div>
            <div className="middle bgmain mt-1">
              <div className="settingbox">
                <div>
                  <table className="mb-30 table table-strip w-100 tradesymlist">
                    <tbody>
                      <tr
                        onClick={() => {
                          setLeverageSelection("1:100");
                        }}
                      >
                        <td className="w-75 text-black font-11 f-arial">1:100</td>
                        <td className="w-25 text-right">
                          {leverageSelection === "1:100" && (
                            <i className="fa-solid fa-check font-16"></i>
                          )}
                        </td>
                      </tr>
                      <tr
                        onClick={() => {
                          setLeverageSelection("1:200");
                        }}
                      >
                        <td className="w-75 text-black font-11 f-arial">1:200</td>
                        <td className="w-25 text-right">
                          {leverageSelection === "1:200" && (
                            <i className="fa-solid fa-check font-16"></i>
                          )}
                        </td>
                      </tr>
                      <tr
                        onClick={() => {
                          setLeverageSelection("1:300");
                        }}
                      >
                        <td className="w-75 text-black font-11 f-arial">1:300</td>
                        <td className="w-25 text-right">
                          {leverageSelection === "1:300" && (
                            <i className="fa-solid fa-check font-16"></i>
                          )}
                        </td>
                      </tr>
                      <tr
                        onClick={() => {
                          setLeverageSelection("1:400");
                        }}
                      >
                        <td className="w-75 text-black font-11 f-arial">1:400</td>
                        <td className="w-25 text-right">
                          {leverageSelection === "1:400" && (
                            <i className="fa-solid fa-check font-16"></i>
                          )}
                        </td>
                      </tr>
                      <tr
                        onClick={() => {
                          setLeverageSelection("1:500");
                        }}
                      >
                        <td className="w-75 text-black font-11 f-arial">1:500</td>
                        <td className="w-25 text-right">
                          {leverageSelection === "1:500" && (
                            <i className="fa-solid fa-check font-16"></i>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      {view === "deposit" &&
        <div className="">
          <div className="header">
            <div className="header-box">
              <div
                className="font-14 himg text-blue w-25"
                onClick={() => {
                  setView("Register");
                }}
              >
                <img src={"/images/back-arrow-blue.svg"} className="" alt="" />
              </div>
              <div className="header-name w-50 text-center">Deposit</div>
              <div className="himg w-25">&nbsp;</div>
            </div>
            <div className="middle bgmain mt-1">
              <div className="settingbox">
                <div>
                  <table className="mb-30 table table-strip w-100 tradesymlist">
                    <tbody>
                      <tr
                        onClick={() => {
                          setDepositSelection("5000");
                        }}
                      >
                        <td className="w-75 text-black font-11 f-arial">5000 USD</td>
                        <td className="w-25 text-right">
                          {depositSelection === "5000" && (
                            <i className="fa-solid fa-check font-16"></i>
                          )}
                        </td>
                      </tr>
                      <tr
                        onClick={() => {
                          setDepositSelection("10000");
                        }}
                      >
                        <td className="w-75 text-black font-11 f-arial">10000 USD</td>
                        <td className="w-25 text-right">
                          {depositSelection === "10000" && (
                            <i className="fa-solid fa-check font-16"></i>
                          )}
                        </td>
                      </tr>
                      <tr
                        onClick={() => {
                          setDepositSelection("15000");
                        }}
                      >
                        <td className="w-75 text-black font-11 f-arial">15000 USD</td>
                        <td className="w-25 text-right">
                          {depositSelection === "15000" && (
                            <i className="fa-solid fa-check font-16"></i>
                          )}
                        </td>
                      </tr>
                      <tr
                        onClick={() => {
                          setDepositSelection("20000");
                        }}
                      >
                        <td className="w-75 text-black font-11 f-arial">20000 USD</td>
                        <td className="w-25 text-right">
                          {depositSelection === "20000" && (
                            <i className="fa-solid fa-check font-16"></i>
                          )}
                        </td>
                      </tr>
                      <tr
                        onClick={() => {
                          setDepositSelection("25000");
                        }}
                      >
                        <td className="w-75 text-black font-11 f-arial">25000 USD</td>
                        <td className="w-25 text-right">
                          {depositSelection === "25000" && (
                            <i className="fa-solid fa-check font-16"></i>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      {view === "messages" && (
        <Messages
          toSettings={() => {
            setView("main");
          }}
        />
      )}
      {/* MESSAGE END */}

      {/* BAN SCRIPTS ALL SCREEN START */}
      {view === "ban" && (
        <BanScripts
          toSettings={() => {
            setView("main");
          }}
        />
      )}
      {/* BAN SCRIPTS ALL SCREEN END */}

      {/* INVOICE ALL SCREEN START */}
      {/* MESSAGE START */}
      {view === "invoice" && (
        <Invoice
          toSettings={() => {
            setView("main");
          }}
        />
      )}
      {/* MESSAGE END */}
      {/* INVOICE ALL SCREEN END */}

      {/* LEDGER ALL SCREEN START */}
      {/* MESSAGE START */}
      {view === "ledger" && (
        <>
          <Ledger
            toSettings={() => {
              setView("main");
            }}
          />
        </>
      )}
      {view === "feedback" && (
        <>
          <Feedback
            toSettings={() => {
              setView("main");
            }}
          />
        </>
      )}
      <>
        {/* <div className="login-popup">
          <Modal
            className="login"
            show={showDisclaimerModal}
            onHide={() => closeDisclaimerModal()}
            backdrop="static"
            dialogAs={eodModal}
            animation={false}
            size="sm"
            centered
          >
            <Modal.Header closeButton style={{ border: "none" }}>
              <Modal.Title>Disclaimer</Modal.Title>
            </Modal.Header>
            <Modal.Body
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <DisclaimerModal
                toSettings={() => {
                  setView("main");
                }}
                closeDisclaimerModal={closeDisclaimerModal}
              />
            </Modal.Body>
          </Modal>
        </div> */}
      </>
      {(view === "changePassword" || view === "changeApiPassword") && (
        <>
          <ChangePassword
            toSettings={() => {
              setView("main");
            }}
            type={
              view === "changePassword" ? "changePassword" : "changeApiPassword"
            }
          />
        </>
      )}
      {/* LEDGER ALL SCREEN END */}
    </>
  );
};

export default Setting;
